import React from "react";
import { useTranslation } from "react-i18next";
import type { Class } from "types/Class";

interface ClassSelectionDialogProps {
  classes: Class[];
  onCancel: () => void;
  onClassSelect: (classItem: Class) => void;
}

const ClassSelectionDialog: React.FC<ClassSelectionDialogProps> = ({
  classes,
  onCancel,
  onClassSelect,
}) => {
  const { t } = useTranslation();

  return (
    <div className="fixed top-0 left-0 w-full h-full bg-black/50 flex justify-center items-center z-[99]">
      <div className="w-[90%] md:w-[70%] lg:w-1/2 bg-white z-[100] shadow-lg">
        <div className="p-5">
          <h2 className="text-lg font-semibold text-center mb-4">
            {t("_class.select_class_to_delete", {
              defaultValue: "削除するクラスを選択する",
            })}
          </h2>

          <div className="max-h-80 overflow-y-auto border border-gray-200">
            <table className="w-full border-collapse">
              <thead>
                <tr className="bg-gray-100">
                  <th className="text-center py-2 px-4 border-b">
                    {t("_class.class_name", { defaultValue: "クラス名" })}
                  </th>
                  <th className="text-center py-2 px-4 border-b">
                    {t("_class.registered_students", {
                      defaultValue: "登録園児数",
                    })}
                  </th>
                </tr>
              </thead>
              <tbody>
                {classes.map((classItem) => (
                  <tr
                    key={classItem.id}
                    className="border-b hover:bg-gray-50 cursor-pointer"
                    onClick={() => onClassSelect(classItem)}
                  >
                    <td className="py-3 px-4">
                      <div className="border border-gray-300 rounded px-2 py-1 text-center">
                        {classItem.year} - {classItem.name}
                      </div>
                    </td>
                    <td className="text-center py-3 px-4">
                      {classItem.number_of_student || 0}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="flex justify-center mt-6">
            <button
              onClick={onCancel}
              className="w-1/3 border border-gray-300 bg-white hover:bg-gray-50 text-gray-800 py-2 px-4 rounded"
            >
              {t("_generic.cancel", { defaultValue: "キャンセル" })}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClassSelectionDialog;
